import { useMemo, useState } from 'react';
import { useBlogContext } from '../../../context/BlogContext';
import CustomTable from '../../Custom/Table';
import TableSearch, { filterRows } from '../../Custom/TableSearch';
import useBlogTable from './useBlogTable';

const BlogTable = () => {

    const { columns } = useBlogTable()
    const {blogs} = useBlogContext()
    const [filtroBusqueda, setFiltroBusqueda] = useState('')

    const blogsDate = useMemo(() => {
        const activos = [...blogs].filter(blog => blog.activo).sort((a, b) => new Date(b.fechaRegistro).getTime() - new Date(a.fechaRegistro).getTime());
        return filterRows(activos, filtroBusqueda, ['titulo', 'descripcion_breve', 'contenido', 'categorias'])
    }, [blogs, filtroBusqueda])

    return (
        <>
            <TableSearch
                value={filtroBusqueda}
                onChange={setFiltroBusqueda}
                label="Buscar blog"
                placeholder="Título, descripción, contenido o categoría..."
            />
            <CustomTable rows={blogsDate} columns={columns} />
        </>
    )

}

export default BlogTable
